import { useContext, useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { UserModuleContext } from "../../context/UserModuleContext";

export const useAdInfo = () => {
    const [state, setState] = useState({ data: null, isLoaded: false, error: null });
    const { authState } = useOktaAuth();
    const { userModule, setUserModule } = useContext(UserModuleContext);

    useEffect(() => {
        if (!userModule.isOpen) return;

        const fetchAdInfo = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/user/ad/info`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: authState.accessToken.accessToken,
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify({ userId: userModule.userId }),
                    }
                );

                if (!response.ok) {
                    throw new Error(`User ${userModule.userId} not found in AD`);
                }

                const result = await response.json();
                setUserModule((prev) => ({ ...prev, ADData: result }));
                setState({ data: result, isLoaded: true, error: null });
            } catch (error) {
                setState({ data: null, isLoaded: true, error });
            }
        };

        fetchAdInfo();
    }, [userModule.isOpen, userModule.userId, authState.accessToken.accessToken, setUserModule]);

    return state;
};
